import Icons from 'assets/icons';

export const getIconByFileType = (type: string): React.JSX.Element => {
  const TYPES: Record<string, React.JSX.Element> = {
    pdf: (
      <Icons.PdfFile customClass="w-9 h-11 mx-auto my-3" aria-hidden="true" />
    ),
    xlsx: (
      <Icons.XlsFile customClass="w-9 h-11 mx-auto my-3" aria-hidden="true" />
    ),
    pptx: (
      <Icons.PptFile customClass="w-9 h-11 mx-auto my-3" aria-hidden="true" />
    ),
    docx: (
      <Icons.DocFile customClass="w-9 h-11 mx-auto my-3" aria-hidden="true" />
    ),
  };

  return (
    TYPES[type] || (
      <Icons.DefaultFile
        customClass="w-9 h-11 mx-auto my-3"
        aria-hidden="true"
      />
    )
  );
};

export const readebleFileSize = (size: number): string => {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

  return `${Number((size / Math.pow(1024, i)).toFixed(2))} ${
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  }`;
};

export const getFileFormat = (fileName = ''): string =>
  fileName.split('.').pop()?.toLowerCase() ?? '';
